import PensionAnalysis from './PensionAnalysis';

export default PensionAnalysis;
